<video autoplay #localVideoElementOpencv
       id="localVideoElementOpencv"
       class="videoElementCSS" width="640"
       height="480"></video>
<canvas id="canvasLocalOutputOpencv" [style.display]="((opencvService.started)? 'block': 'none')" width="640"
        height="480"
        #canvasLocalOutput class="canvasElementCSS">
</canvas>
<button (click)="cameraService.fullScreen()" id="fullScreenButton">
  <img src="assets/images/full-screen.png" height="26" width="26"/>
</button>

